<template>
  <div class="auth-main">
    <main
      id="main"
      class="main--login"
      data-page-id="login"
    >
      <section class="section-login">
        <Header :is-whitelabel="isWhitelabel" />
        <div class="login-form-wrapper">
          <div class="loginv2-container p-b-20">
            <div v-if="!displayRequireTwoFactorAuthConfig" class="row">
              <div
                class="login_logo"
                :class="{ 'login_logo--ringba': !isWhitelabel }"
              />
            </div>
            <LoginForm
              v-if="!twoFactorAuthRequired && !displayRequireTwoFactorAuthConfig && !isTransitionPending"
              :action-status="actionStatus"
              @login="onLogin"
            />
            <TwoFactorForm
              v-if="twoFactorAuthRequired && !displayRequireTwoFactorAuthConfig"
              back-button-description="BACK_LOGIN_LINK"
              :action-status="twoFactorActionStatus"
              @two-factor-verify="onLoginTwoFactor"
            />
            <TwoFactorAuthMFAForm
              v-if="displayRequireTwoFactorAuthConfig"
              :is-login-flow="true"
              :enforce-mfa="enforceMfa"
              @redirect-to-dashboard="redirectToDashboard"
            />
          </div>
        </div>
      </section>
      <Footer v-if="!isWhitelabel" />
      <WhitelabelFooter v-if="isWhitelabel" />
    </main>
  </div>
</template>

<script>
import Footer from '@/modules/auth/components/Footer';
import Header from '@/modules/auth/components/Header';
import LoginForm from '@/modules/auth/components/Login/LoginForm';
import TwoFactorForm from '@/modules/auth/components/Login/TwoFactorForm';
import TwoFactorAuthMFAForm from '@/modules/twoFactorAuth/components/TwoFactorAuthMFAForm';
import WhitelabelFooter from '@/modules/auth/components/WhitelabelFooter';
import { mapActions, mapState } from 'vuex';
import { $ngStateService, cacheService } from '@/angularBridgeCode/ringbaPortal.servicesModule';
import { isStaging } from '@/core/utilities';
import { STATUS_SUCCESS, getStatus } from '@/store/helpers';

export default {
  components: {
    Footer,
    Header,
    LoginForm,
    WhitelabelFooter,
    TwoFactorForm,
    TwoFactorAuthMFAForm
  },

  props: {
    isWhitelabel: {
      type: Boolean,
      default() {
        return true;
      },
    },
  },

  data() {
    return {
      isEnabled: false,
      enforceMfa: false,
      isTransitionPending: false
    };
  },

  computed: {
    ...mapState('auth', {
      actionStatus: (state) => getStatus(state, 'sendLoginRequest'),
      twoFactorActionStatus: state => getStatus(state, 'sendLoginRequestWithTwoFactor'),
      twoFactorAuthRequired: state => state.twoFactorAuthRequired
    }),
    // Determine when to show the user the MFA set up form
    displayRequireTwoFactorAuthConfig() {
      return !this.twoFactorAuthRequired && this.actionStatus.status === STATUS_SUCCESS && !isStaging;
    }
  },
  methods: {
    ...mapActions('auth', [
      'sendLoginRequest',
      'sendLoginRequestWithTwoFactor'
    ]),

    async onLogin(data) {
      await this.sendLoginRequest(data);
      const authData = cacheService.get('authService.authorizationData');
      this.enforceMfa = authData?.enforceMfa || false;
      if (this.displayRequireTwoFactorAuthConfig) {
        return;
      }
      if (!this.twoFactorAuthRequired) {
        this.redirectIfSuccess(this.actionStatus);
      } 
    },

    async onLoginTwoFactor(data) {
      this.isTransitionPending = true;
      await this.sendLoginRequestWithTwoFactor(data);
      this.redirectIfSuccess(this.twoFactorActionStatus);
    },
    
    redirectIfSuccess(action) {
      if (action.status === STATUS_SUCCESS) {
        $ngStateService.go('dashboard.main');
      }
    },
    redirectToDashboard() {
      this.isTransitionPending = true;
      this.redirectIfSuccess(this.actionStatus);
    }
  },

};
</script>

<style>
</style>